import { Dictionary } from "../../util/collection/Dictionary";
import { ObjectUtil } from "../../util/object/ObjectUtil";
/**
 * AppModel.ts
 */
export class AppModel {
    constructor() {
        this.models = new Dictionary();
    }
    initialise(value) {
        this.parameters = value;
    }
    getModel(type) {
        let model;
        let key = type.getName();
        if (this.models.containsKey(key)) {
            model = this.models.getValue(key);
        }
        else {
            model = ObjectUtil.create(type);
            this.models.setValue(key, model);
        }
        return model;
    }
    setTime(value) {
        this.time = value;
    }
    setOperatorData(value) {
        this.operatorData = value;
    }
    setWrapperObject(value) {
        this.wrapperObject = value;
    }
    getTime() {
        return this.time;
    }
    getParameters() {
        return this.parameters;
    }
    getOperatorData() {
        return this.operatorData;
    }
    getWrapperObject() {
        return this.wrapperObject;
    }
}
//# sourceMappingURL=AppModel.js.map